// @flow
import React from 'react';

import { searchExact } from 'Api'

import Layout from 'pages/Avila/Biblio/List/layout_find'

import SearchModal from './SearchModal';
import type { Props as SearchModalProps } from './SearchModal'

type Props = {
    onClose: any => any,
    actions: Array<any>,
    filterData: Array<any>
}
export default ({
    onClose,
    actions = [],
    filterData = [],
}: Props & SearchModalProps) => {

    return (
        <SearchModal
            title={"Ajouter une biblio"} onClose={onClose}
            actions={actions}
            filterData={filterData}
            searchFunction={async query => {

                const expos = await searchExact({
                    type: 'biblio',
                    query
                });

                return expos;
            }}
            renderList={({ data, actions }) => {

                return (
                    <Layout data={data} filterData={filterData} actions={actions} />
                )
            }}
        />
    )
}